const PaymentActionTypes = {
  SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
  SET_BILLING_ADDRESS: 'SET_BILLING_ADDRESS',
  UPDATE_BILLING_ADDRESS: 'UPDATE_BILLING_ADDRESS',
  BILLING_SAME_AS_SHIPPING: 'BILLING_SAME_AS_SHIPPING',
  RESET_PAYMENT: 'RESET_PAYMENT'
};

export default PaymentActionTypes;
